import { Rating } from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

export interface ReviewDimensionProps {
  title: string;
  description: string;
  rate: number;
  onRateChange: (rate: number) => void;
}

export const ReviewDimension: FC<ReviewDimensionProps> = ({
  title,
  description,
  rate,
  onRateChange,
}) => {
  return (
    <div className="space-y-2 border-t border-leland-gray-stroke py-6">
      <h2 className="text-xl font-medium leading-7 text-leland-gray-dark">
        {title}
      </h2>
      <p className="text-lg leading-6 text-leland-gray-light">{description}</p>
      <Rating rate={rate} hoverable onSaveRating={onRateChange} />
    </div>
  );
};
